import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._8};
  width: 100%;
  margin-top: auto;
`;
